import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-row-center-center pt-30 pagination" }

import { ref, withDefaults, watch } from 'vue';
	import config from '@/api/config';
	
	interface main {
		page ?: string | number,
		total ?: string | number,
	}
	
	
export default /*#__PURE__*/_defineComponent({
  __name: 'PagingNum',
  props: {
    page: { default: 1 },
    total: { default: 0 }
  },
  emits: ["update:page", "change"],
  setup(__props: any, { emit: __emit }) {

	const props = __props
	
	const emits = __emit;
	const pages = ref(1);
	const size = ref(config.PagesSize[0]);
	
	watch(() => props.page, (n : any) => {
		pages.value = n;
	});
	
	// 显示条数改变
	const handleSizeChange = (params : any) => {
		size.value = params;
		emits("change", {
			type: 1,
			page: 1,
			size: params,
		});
	};
	// 分页改变
	const handleCurrentChange = (params : any) => {
		pages.value = params;
		emits("update:page", params);
		emits("change", {
			type: 2,
			page: params,
			size: size.value,
		})
	};

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_pagination, {
      background: "",
      layout: "prev, pager, next, sizes, jumper",
      "page-sizes": _unref(config).PagesSize,
      total: _ctx.total,
      "current-page": pages.value,
      "page-size": size.value,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
  ]))
}
}

})